import React from "react";
import { toFixedNumber } from "../../../../../../helpers/Utils";

function OrderTotalComponent({ total_price, vat_code_pvm, total_discounts_tax_incl = 0, total_discounts = 0 }) {
  const discountToSubtract = total_discounts === 0 ? total_discounts_tax_incl : 0;
  const finalPrice = toFixedNumber(total_price - discountToSubtract);

  return (
    <div className="text-center">
      <span className="badge badge-warning badge-middle  badge-order-price">
        Order price: {Number(finalPrice).toFixed(2)} {"\u20AC"}{" "}
        {vat_code_pvm && <span>{"(VAT excl.)"}</span>}
      </span>
    </div>
  );
}

export default OrderTotalComponent;
